export interface LayerBox {
  /** Haut du décor dans la page, en px. */
  top: number;
  height: number;
  /** Hauteur de la fenêtre. */
  viewport: number;
}

/**
 * Décalage d'un décor selon sa traversée de la fenêtre : -distance/2 quand
 * il entre par le bas, 0 au milieu, +distance/2 quand il sort par le haut.
 */
export function parallaxOffset(scrollY: number, box: LayerBox, distance: number): number {
  const travel = box.viewport + box.height;
  if (travel <= 0) return 0;
  const progress = Math.min(Math.max((scrollY + box.viewport - box.top) / travel, 0), 1);
  return (progress - 0.5) * distance;
}
